import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { PreviewItemModel } from '../../file-preview.component';
import { BasePreviewComponent } from '../base-preview/base-preview.component';

@UntilDestroy()
@Component({
  selector: 'online-preview',
  templateUrl: './online-preview.component.html',
  styleUrls: ['./online-preview.component.scss', '../../../file-preview-shared.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OnlinePreviewComponent extends BasePreviewComponent {
  src: string;
  private readonly PREFIX = 'https://view.officeapps.live.com/op/embed.aspx?src=';

  @Input() set model(model: PreviewItemModel) {
    this._model = model;
    if (!this.modelValidated()) {
      return;
    }
    const srcUrl = model?.item?.srcUrl;
    if (srcUrl) {
      const url = new URL(srcUrl);
      const searchParams = encodeURIComponent(url.search);
      this.src = `${this.PREFIX}${url.origin}${url.pathname}${searchParams}`;
      this.cdr.markForCheck();
    }
  }

  get model(): PreviewItemModel {
    return this._model;
  }
    
  get fileHeight(): string {
    return `calc(100% - 50px - ' + ${this.footerWidth} + 'px)`;
  }
}
